import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling

function NationalGeospatialMetadataProfile() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div className="pdf-page">
    <iframe
      src={t('NationalGeospatialMetadataProfile_pdf')}
      title="PDF Document"
    />
  </div>
  );
}

export default NationalGeospatialMetadataProfile;
